import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { Sidebar } from '@shared/sidebar/sidebar';
import { Navbar } from '@shared/navbar/navbar';
import { Footer } from '@shared/footer/footer';
import { Service as LayoutService } from '@services/layout.service';

declare const Scrollbar: any;

@Component({
    standalone: true,
    selector: 'app-admin-layout',
    templateUrl: './admin-layout.html',
    styleUrls: ['./admin-layout.scss'],
    imports: [CommonModule, RouterModule, RouterOutlet, TranslateModule, Navbar, Sidebar, Footer],
})
export class AdminLayout implements OnInit, AfterViewInit, OnDestroy {
    public currentYear = new Date().getFullYear();

    constructor(private LayoutService: LayoutService) {}

    onSidenavHover(hovered: boolean) {
        this.LayoutService.setMiniHover(hovered);
    }

    ngOnInit() {
        document.body.classList.add('g-sidenav-show', 'bg-gray-100');
    }

    ngAfterViewInit() {
        try {
            const el = document.querySelector('#sidenav-scrollbar');
            if (el && typeof Scrollbar !== 'undefined') {
                Scrollbar.init(el as any, { damping: 0.5 });
            }
        } catch (e) {
            // ignore init errors
            console.warn('Scrollbar init failed', e);
        }
    }

    ngOnDestroy() {
        this.LayoutService.setMiniHover(false);
        document.body.classList.remove('g-sidenav-show', 'bg-gray-100');
    }
}